export default __webpack_public_path__ + "static/media/cancellation1.4448ad6f.svg";